/** @typedef {import('../lib/types.js').NoteContentBlock} NoteContentBlock */
import { meetingDemoTabContent } from './demoTabContent/meetingDemo.seed'
import { meetingYouTabContent } from './demoTabContent/meetingYou.seed'

/** @type {Record<string, Record<string, NoteContentBlock[]>>} */
export const NOTES_DEMO_TAB_CONTENT = {
  'n-meeting-you': meetingYouTabContent,
  'n-meeting-demo': meetingDemoTabContent,
}

export { buildDefaultTabContent } from './buildDefaultTabContent'
